import React, { useState, useEffect } from 'react';

import MultiListPopUpESD from '../atoms/MultiListPopUpESD';

function FromMoveListESD(props) {

    return (
        <div className="row form-fields">
            <div className="label col-6">
                <label></label>
            </div>
            <div className="item col-6">
                <button
                    onClick={() => { props.setShowPopUpIT(true); }}
                    className="btn btn-primary mb-2">
                    Continue <span className="bi bi-gear-fill"></span>
                </button>

                <MultiListPopUpESD
                    titleESD={props.labelIT}
                    showESD={props.showPopUpIT}
                    showsetterESD={props.setShowPopUpIT}
                    dataESD={props.dataIT}
                    datasetterESD={props.datasetterIT}
                    setLoadingESD={props.setLoadingIT}   // pass loader setter
                    setProgress={props.setProgress}     // pass progress setter
                    setTotal={props.setTotal}           // pass total setter
                />
            </div>
        </div>
    )
}

export default FromMoveListESD